import { TOURNAMENT_OVERVIEW } from 'constants/tmxConstants';

export function tournamentInfoBlock(): HTMLElement {
  const div = document.createElement('div');
  div.className = 'is-marginless tab_container';
  div.style.width = 'inherit';
  div.id = 'o-tab';

  div.innerHTML = `
    <div class="tab_section events_tab">
        <div class="section">
            <div id=${TOURNAMENT_OVERVIEW} class="box tournament-information">
            </div>
        </div>
    </div>
  `;

  return div;
}
